// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filePreview_itm {
    object-fit: cover;
    border:solid 0.1rem #C1C1C1;
    border-radius: 1.007rem;
    height: 10rem;
    max-width: 10rem;
}

.responseModelDialogBackground {
    position: fixed;
    top: 0;
    left: 0;
    opacity: 70%;
    background-color: #000000;
    width: 100vw;
    height: 100vh;
    z-index: 1;
}

.responseModelDialogBox {
    position: fixed;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border-radius: 1.25rem;
    padding: 2%;
    width: 70%;
    max-height: 80%;
    overflow: auto;
    font-size: 1.25rem;
    line-height: 2rem;
}

.responseModelDialog_action {
    display: flex;
    justify-content: center;
    padding: 1% 2.5% 0;
}

.responseModelDialog_action_btn {
    text-align: center;
    background: transparent;
    padding: .8rem 2rem;
    cursor: pointer;
    border-radius: 1.15rem;
    border: 1px solid #00127E;
}

.camera_btn_left {
    background: #00127E;
    color: white;
    margin-right: 5%;
}

.camera_btn_right {
    border: 1px solid #FF4425;
    color: #FF4425;
    margin-left: 5%;
}

.finishFormDialog_icn {
    width: 5.5rem;
    height: 5.5rem;
    object-fit: contain;
    align-self: center;
}

.responsemodel_cancel_icon {
    width: 1.75rem;
    height: 1.75rem;
    object-fit: contain;
    align-self: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/components/common/responseModel/styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB","sourcesContent":[".filePreview_itm {\n    object-fit: cover;\n    border:solid 0.1rem #C1C1C1;\n    border-radius: 1.007rem;\n    height: 10rem;\n    max-width: 10rem;\n}\n\n.responseModelDialogBackground {\n    position: fixed;\n    top: 0;\n    left: 0;\n    opacity: 70%;\n    background-color: #000000;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1;\n}\n\n.responseModelDialogBox {\n    position: fixed;\n    z-index: 1;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    background: #FFFFFF;\n    border-radius: 1.25rem;\n    padding: 2%;\n    width: 70%;\n    max-height: 80%;\n    overflow: auto;\n    font-size: 1.25rem;\n    line-height: 2rem;\n}\n\n.responseModelDialog_action {\n    display: flex;\n    justify-content: center;\n    padding: 1% 2.5% 0;\n}\n\n.responseModelDialog_action_btn {\n    text-align: center;\n    background: transparent;\n    padding: .8rem 2rem;\n    cursor: pointer;\n    border-radius: 1.15rem;\n    border: 1px solid #00127E;\n}\n\n.camera_btn_left {\n    background: #00127E;\n    color: white;\n    margin-right: 5%;\n}\n\n.camera_btn_right {\n    border: 1px solid #FF4425;\n    color: #FF4425;\n    margin-left: 5%;\n}\n\n.finishFormDialog_icn {\n    width: 5.5rem;\n    height: 5.5rem;\n    object-fit: contain;\n    align-self: center;\n}\n\n.responsemodel_cancel_icon {\n    width: 1.75rem;\n    height: 1.75rem;\n    object-fit: contain;\n    align-self: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
